export const errorMessage = Object.freeze({
  203: {
    title: 'Error 203: Something Went Wrong.',
    msg: `The application cannot fulfill your request at this time.<br>
Please try again later.`,
  },
  500: {
    title: 'Error 500: Internal Server Error',
    msg: `The server was unable to fulfill the request sent by your browser. <br>
  Please try one of the following to resolve this issue: <br><br>
  1. Refresh the page<br>
  2. Clear your browser’s cache and/or cookies<br>
  3. Try accessing the page on a different network<br><br>
  If these methods do not solve the issue, please try again later.`,
  },
  404: {
    title: 'Error 404: Not Found',
    msg: `The page you are trying to access does not exist.<br>
Please try navigating to a different page.`,
  },
  501: {
    title: 'Error 501: Not Implemented',
    msg: `The server does not currently support this action. <br>
Please try one of the following to resolve this issue: <br><br>
1. Refresh the page<br>
2. Clear your browser’s cache and/or cookies<br>
3. Try accessing the page on a different network<br><br>
If these methods do not solve the issue, please try again later.
`,
  },
  502: {
    title: 'Error 502: Bad Gateway',
    msg: `The server was unable to fulfill the request sent by your browser.<br> 
Please try one of the following to resolve this issue:<br><br>
1. Refresh the page<br>
2. Clear your browser’s cache and/or cookies<br>
3. Try accessing the page on a different network<br><br>
If these methods do not solve the issue, please try again later.`,
  },
  503: {
    title: 'Error 503: Service Unavailable',
    msg: `The server was unable to handle this request.<br>
Please try one of the following to resolve this issue:<br><br>
  1. Refresh the page<br>
  2. Clear your browser’s cache and/or cookies<br>
  3. Try accessing the page on a different network<br><br>
  If these methods do not solve the issue, please try again later.`,
  },
  504: {
    title: 'Error 504: Gateway Timeout',
    msg: `The server timed out and was unable to fulfill the request sent by your browser.<br>
Please try one of the following to resolve this issue:<br><br>
  1. Refresh the page<br>
  2. Clear your browser’s cache and/or cookies<br>
  3. Try accessing the page on a different network<br><br>
  If these methods do not solve the issue, please try again later.`,
  },
  505: {
    title: 'Error 505: HTTP Version Not Supported',
    msg: `The server cannot process the request due to an incompatible HTTP protocol version.<br>
Please try one of the following to resolve this issue:<br><br>
  1. Refresh the page<br>
  2. Clear your browser’s cache and/or cookies<br>
  3. Try accessing the page on a different network<br><br>
  If these methods do not solve the issue, please try again later.`,
  },
})
